<template>
  <div class="d-flex align-center">
    <span :class="{ 'primary--text': estFaux }">
      {{ faux | soustypedocument }}
    </span>
    <v-switch
      color="primary"
      inset
      v-model="model"
      :true-value="vrai"
      :false-value="faux"
      class="ml-2 mr-2"
      v-bind="$attrs"
      :data-testid="dataTestid"
    >
      <template v-slot:message="{ message }">
        <div style="position: absolute; white-space: nowrap;">{{ message }}</div>
      </template>
    </v-switch>
    <span :class="{ 'primary--text': estVrai }">
      {{ vrai | soustypedocument }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    "data-testid": {
      type: String,
      required: false,
    },
    value: {
      type: String,
      required: true,
    },
    faux: {
      type: String,
      required: true,
    },
    vrai: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      model: this.value,
    };
  },

  watch: {
    value() {
      this.model = this.value;
    },
    model() {
      if (this.model !== this.value) {
        this.$emit("input", this.model);
      }
    },
  },

  computed: {
    estVrai() {
      return this.value === this.vrai;
    },
    estFaux() {
      return this.value === this.faux;
    },
  },
};
</script>
